import { getUser } from 'services/local/auth';
import { DEFAULT_ITEMS } from 'constants/uxFeaturesOrder';
import type { LocalStorageFunctions, LocalUxFeaturesOrder } from './types';

const UX_FEATURES_ORDER: string = 'ux-features-order';

const getLocalStorageUxFeaturesOrder = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return DEFAULT_ITEMS;
  const choice = fn.readObject<Record<string, string[]>>(UX_FEATURES_ORDER);
  if (!choice?.[user.user.email]) return DEFAULT_ITEMS;
  return choice[user.user.email];
};

const setLocalStorageUxFeaturesOrder = (fn: LocalStorageFunctions) => (data: string[]) => {
  const user = getUser(fn)();
  if (!user) return;
  let choice = fn.readObject<Record<string, string[]>>(UX_FEATURES_ORDER);
  if (!choice) {
    choice = {};
  }
  choice[user.user.email] = data;
  fn.writeObject(UX_FEATURES_ORDER, choice);
};

const delLocalStorageUxFeaturesOrder = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return;
  const choice = fn.readObject<Record<string, string[]>>(UX_FEATURES_ORDER);
  if (!choice?.[user.user.email]) return;
  delete choice[user.user.email];
  fn.writeObject(UX_FEATURES_ORDER, choice);
};

const uxFeaturesOrder = (fn: LocalStorageFunctions): LocalUxFeaturesOrder => ({
  getLocalStorageUxFeaturesOrder: getLocalStorageUxFeaturesOrder(fn),
  setLocalStorageUxFeaturesOrder: setLocalStorageUxFeaturesOrder(fn),
  delLocalStorageUxFeaturesOrder: delLocalStorageUxFeaturesOrder(fn)
});

export default uxFeaturesOrder;
